import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderByPipe implements PipeTransform {

  // transform(value: unknown, ...args: unknown[]): unknown {
  //   return null;
  // }
  transform(array: any, field: string, order: string = "asc"): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      var x, y;
      if (isNaN(a[field])) {
        x = a[field].toLowerCase();
        y = b[field].toLowerCase();
        if (order == "desc") {
          y = a[field].toLowerCase();
          x = b[field].toLowerCase();
        }
      } else {
        x = a[field];
        y = b[field];
        if (order == "desc") {
          y = a[field];
          x = b[field];
        }
      }

      if (x < y) {
        return -1;
      } else if (x > y) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }

}
